export default "__VITE_ASSET__Bc1u6YXl__"